import React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as searchActions from '~/search2/actions';
import CvssService from '~/utils/CvssService';
const options = [{ value: 'cvss2', label: 'CVSS v2' }, { value: 'cvss3', label: 'CVSS v3' }];
type CVSSDropdownProps = {
  actions: object;
  searchDataState: object;
};
class CVSSDropdown extends React.Component<CVSSDropdownProps, {}> {
  componentDidMount = () => {
    // On load, check cookie on the previous selection
    const value = CvssService.isCvss2Selected() ? 'cvss2' : 'cvss3';
    this.props.actions.updateCvssSelection(value);
  };
  onChange = option => {
    // Set in cookie for future reference
    CvssService.setCvssSelection(option.value);
    this.props.actions.updateCvssSelection(option.value);
    const { searchDataState = {} } = this.props;
    const { filters = {} } = searchDataState;
    if (filters.severity) {
      // Handle situation when user has cvss2_severity selected and select
      // cvss3 inside the dropdown, then we'll update to cvss3_severity. Vice-verse
      // for cvss3 to cvss2
      const isCvss3Selected = option.value === 'cvss3';
      const severityKey = isCvss3Selected ? 'cvss3_severity' : 'cvss2_severity';
      this.props.actions.setFilter(severityKey, filters.severity);
    }
  };
  render() {
    const { searchDataState = {} } = this.props;
    const { cvss = 'cvss2', filters = {} } = searchDataState;
    // Disable this control if filter type has library
    const filterTypeUsed = type => filters.type && filters.type.indexOf(type) !== -1;
    const disabled = filterTypeUsed('library') ? true : false;
    return (
      <Select
        options={options}
        onChange={this.onChange}
        onInputChange={this.onInputChange}
        value={cvss}
        disabled={disabled}
        clearable={false}
        className="font--12"
      />
    );
  }
}
function mapStateToProps(state) {
  return {
    searchDataState: state.searchDataState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(searchActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CVSSDropdown);
